export const CUSTOMER_QUOTE_TYPES = {
  PPC: 'ppc',
  ORGANIC: 'organic',
}
